import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import { useStyles } from './TakisSkeleton.styles';

const TakisRecipeListItemsSkeleton = () => {
  const classes = useStyles();

  return (
    <>
      <>
        <Grid className={classes.takisRecipeListItemContainer} container item sx={12} lg={6}>
            <Skeleton className={classes.takisRecipeListItem}/>
        </Grid>
        <Grid className={classes.takisRecipeListItemContainer} container item sx={12} lg={6}>
            <Skeleton className={classes.takisRecipeListItem}/>
        </Grid>
        <Grid className={classes.takisRecipeListItemContainer} container item sx={12} lg={6}>
        <Skeleton className={classes.takisRecipeListItem}/>
            </Grid>
        <Grid className={classes.takisRecipeListItemContainer} container item sx={12} lg={6}>
            <Skeleton className={classes.takisRecipeListItem}/>
        </Grid>
        <Grid className={classes.takisRecipeListItemContainer} container item sx={12} lg={6}>
            <Skeleton className={classes.takisRecipeListItem}/>
        </Grid>
        <Grid className={classes.takisRecipeListItemContainer} container item sx={12} lg={6}>
            <Skeleton className={classes.takisRecipeListItem}/>
        </Grid>
      </>
    </>
  );
}

export default TakisRecipeListItemsSkeleton;
